module.exports = __webpack_public_path__ + "img/presentation.0e63a8be.svg";